module.exports = __webpack_public_path__ + "static/media/media2.10e70cc7.png";